import { APICall } from "../../../api_helper";
import { NewNewFormComponentProps } from "../../new_form/NewNewFormComponent";
import { NewNewModalWithFormComponent } from "../../new_modal/NewNewModalWithFormComponent";

export const NewFormModalCardDotMenuItemComponent = (props: {
  props: NewFormModalCardDotMenuItemComponentProps;
  cardData: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <>
      {props.props.showMenuOption(props.cardData) && (
        <NewNewModalWithFormComponent
          props={{
            header: props.props.modalHeader,
            triggerProps: {
              type: "dropdown_item",
              label: props.props.label,
            },
            formComponentProps: props.props.formComponentProps,
            apiCall: props.props.apiCall,
            callback: (data: any) => props.props.callback(data),
          }}
        />
      )}
    </>
  );
};

export type NewFormModalCardDotMenuItemComponentProps = {
  type: "new_form_modal";
  apiCall: APICall;
  label: string;
  modalHeader: string;
  showMenuOption: (data: any) => boolean;
  formComponentProps: NewNewFormComponentProps;
  callback: (data: any) => void;
};
